<div id="preview-container">
    <form [formGroup]="formGroup">
        <mat-card class="card-container">
            <mat-card-header class="card-header">
                <mat-card-title class="header-preview-label"> {{ "form_preview_report.title" | translate }} </mat-card-title>
                <mat-card-subtitle class="report-name"> Report: {{ report_name }} </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-content">
                <mat-form-field class="form-card" hideRequiredMarker>
                    <mat-label class="place-holder"> {{ "form_preview_report.password" | translate }} </mat-label>
                    <input [type]="hide ? 'password' : 'text'" formControlName="password" min="0" max="=6"
                        autocomplete="off" onlyNumber required autofocus matInput />
                    <mat-icon matSuffix (click)="hide = !hide">
                        {{hide ? "visibility_off" : "visibility"}}
                    </mat-icon>
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions class="card-action">
                <button type="submit" mat-button class="btn-apply" matButton="filled" style="text-transform: uppercase;"
                    [disabled]="formGroup.get('password')?.errors"
                    [class]="{'btn-disabled': formGroup.get('password')?.errors}" (click)="onApply()">
                    {{"form_preview_report.apply" | translate}}
                </button>
            </mat-card-actions>
        </mat-card>
    </form>
</div>